export const APP_VERSION =
  typeof __APP_VERSION__ === "string" && __APP_VERSION__ ? __APP_VERSION__ : null;

export const isDesktopApp = () =>
  typeof window !== "undefined" && Boolean(window.electron);

export const getInstalledVersion = () => (isDesktopApp() ? APP_VERSION : null);
